import React from 'react'
import Main from './Main'
import "primeicons/primeicons.css";
function Profile() {
  return (
    <>
    <Main/>
    <div>Profile</div>
    </>
  )
}

export default Profile